import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import Reports from "../../common/reports/Reports";
import GlobalContext from "../../framework/GlobalContext";
import classes from "./FrequencySlabReport.module.css";
import FrequencySlabReportFilter from "./FrequencySlabReportFilter";
import Button from "../../framework/Button";
import Shortcut from "../../framework/Shortcut";
import FrequencySlabDetails from "./frequencySlabDetails";
import Autocomplete from "../../framework/Autocomplete";
import FrequencySlabReportSummary from "./FrequencySlabReportSummary";
import AddFrequency from "./addFrequencySlab";

const FrequencySlabReport = () => {
  const [onFilterShow, setOnFilterShow] = useState(false);
  const [onColumnShow, setOnColumnShow] = useState(false);
  const [rowLevelCTAs, setRowLevelCTAs] = useState([]);
  const [filterParams, setFilterParams] = useState(null);
  const [filterStates, setFilterStates] = useState(null);
  const [currentRowData, setCurrentRowData] = useState(null);
  const [showFrequencySlabDetails, setShowFrequencySlabDetails] =
    useState(false);
  const [showAddFrequencySlab, setShowAddFrequencySlab] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const { currentComponent, setCurrentComponent } = useContext(GlobalContext);
  const reportRef = useRef();
  const refreshRef = useRef();
  const enterRef = useRef();
  const exportRef = useRef();
  const addBtnRef = useRef();

  const refreshData = useCallback((filterData = {}) => {
    reportRef.current.applyFilters(filterData);
  }, []);

  const applyFilterHandler = useCallback((params, filterStates) => {
    setFilterParams(params);
    setFilterStates(filterStates);
  }, []);
  const quickExportHandler = () => {
    reportRef?.current?.quickExport({ fileName: "FrequencySlabReport" });
  };
  const closeFrequencySlabDetails = useCallback(() => {
    setShowFrequencySlabDetails(false);
    setCurrentComponent("grid_reports");
  }, [setCurrentComponent]);

  const closeAddFrequencySlab = useCallback(() => {
    setIsEdit(false);
    setShowAddFrequencySlab(false);
    setCurrentComponent("grid_reports");
  }, [setCurrentComponent]);

  const listener = useCallback((e) => {
    const key = e.key?.toLowerCase();
    const ctrlKey = e.ctrlKey;
    const altKey = e.altKey;
    if (altKey && key === "r") {
      refreshRef.current.click();
      return;
    }
    if (ctrlKey && key === "i") {
      enterRef.current?.click();
      return;
    }
    if (key === "enter") {
      enterRef.current.click();
      return;
    }
    if (ctrlKey && key === "q") {
      setIsEdit(false);
      addBtnRef.current.click();
      return;
    }
  }, []);
  useEffect(() => {
    const allRowCTAs = [
      <Button
        ref={enterRef}
        startIcon={
          <>
            <Shortcut keys={["Enter"]} />/<Shortcut keys={["Ctrl", "I"]} />
          </>
        }
        label="info"
        onClick={() => {
          setShowFrequencySlabDetails(true);
        }}
        isAccessible={currentRowData}
      />,
    ];
    setRowLevelCTAs(allRowCTAs);
  }, [currentRowData]);

  useEffect(() => {
    setCurrentComponent("grid_reports");
  }, [setCurrentComponent]);

  useEffect(() => {
    if (!onFilterShow && !onColumnShow && currentComponent === "grid_reports") {
      document.addEventListener("keyup", listener, false);
    }
    return () => {
      document.removeEventListener("keyup", listener, false);
    };
  }, [currentComponent, listener, onColumnShow, onFilterShow]);
  useEffect(() => {
    refreshData({ isFilterChanged: true, ...filterStates });
  }, [refreshData, filterStates]);
  return (
    <div className={classes["frequency-slab-report-container"]}>
      <Reports
        identifier="frequencySlabReport"
        reportRef={reportRef}
        rowLevelCTAs={rowLevelCTAs}
        filterStates={filterStates}
        filterParams={filterParams}
        onFilterShowClick={setOnFilterShow}
        onColumnShowClick={setOnColumnShow}
        currentRow={(data) => {
          setCurrentRowData(data);
        }}
        onCellClicked={(params) => {
          if (params.column?.colId === "frequencyId")
            setShowFrequencySlabDetails(true);
        }}
        filters={
          <FrequencySlabReportFilter
            reportRef={reportRef}
            filters={(filters) => {
              setFilterStates(filters);
            }}
            onFilterShow={onFilterShow}
            refreshData={refreshData}
            applyFilters={applyFilterHandler}
          />
        }
      />
      <Autocomplete
        show={showFrequencySlabDetails}
        height="60%"
        closeAutoComplete={closeFrequencySlabDetails}
      >
        <FrequencySlabDetails
          frequencySlabCode={currentRowData?.data?._id}
          onEscape={closeFrequencySlabDetails}
        />
      </Autocomplete>
      <Autocomplete
        show={showAddFrequencySlab}
        height=" 80%"
        closeAutoComplete={closeAddFrequencySlab}
      >
        <AddFrequency
          onEscape={closeAddFrequencySlab}
          refreshData={refreshData}
          currentRowData={currentRowData?.data}
          isEdit={isEdit}
        />
      </Autocomplete>
      <FrequencySlabReportSummary
        refreshData={refreshData}
        refreshRef={refreshRef}
        addBtnRef={addBtnRef}
        quickExport={quickExportHandler}
        exportRef={exportRef}
        setShowAddFrequencySlab={setShowAddFrequencySlab}
        setIsEdit={setIsEdit}
      />
    </div>
  );
};

export default FrequencySlabReport;
